export default __webpack_public_path__ + "static/media/IconDesc_CandyCaneDecor.256.47d060c2.png";